import fileDownload from 'js-file-download';
import { format, parseISO } from 'date-fns';

// One CSV field. Always quoted, with inner quotes doubled, because names and payer
// descriptions can contain commas (the shared CsvUtil.matrixToString does no quoting).
// Text starting with = + - @ tab or CR is prefixed with ' so a spreadsheet won't run it as
// a formula; numbers (including negatives) are left as numbers.
const csvField = (value) => {
  let v = value == null ? '' : String(value);
  if (typeof value !== 'number' && /^[=+\-@\t\r]/.test(v)) v = `'${v}`;
  return `"${v.replace(/"/g, '""')}"`;
};

const toDate = (value) => (typeof value === 'string' ? parseISO(value) : value);

// Downloads built in the browser from data already on screen (Visits page cards), so
// they need no server call.
class CsvDownloadUtil {
  // header: array of column labels; rows: array of arrays, same order as header.
  // Starts with a UTF-8 BOM so Excel on Windows reads accented names correctly.
  static download(fileName, header, rows) {
    const lines = [header, ...rows].map((row) => row.map(csvField).join(','));
    fileDownload(`﻿${lines.join('\n')}`, fileName);
  }

  // A report row's { year, month } (month 0-based, as the API sends it) as yyyy-MM.
  // Not the charts' "Nov 25" label: Excel reads that as November 25 of the current year.
  static month(row) {
    return `${row.year}-${String(row.month + 1).padStart(2, '0')}`;
  }

  // doctivity_<name>_<yyyy-MM-dd>_to_<yyyy-MM-dd>.csv for the app's date range
  // ({ start, end } ISO strings), or doctivity_<name>.csv without one.
  static fileName(name, dateRange) {
    if (!dateRange || !dateRange.start || !dateRange.end) {
      return `doctivity_${name}.csv`;
    }
    const from = format(toDate(dateRange.start), 'yyyy-MM-dd');
    const to = format(toDate(dateRange.end), 'yyyy-MM-dd');
    return `doctivity_${name}_${from}_to_${to}.csv`;
  }
}

export { CsvDownloadUtil };
